export const CHECK_DUP_FILTERS = ['create_date_time', 'update_date_time'];
export const AG_FILTER_CLASSNAME = 'ag-filter-from ag-filter-date-from';
export const MAX_DESCRIPTION_CHARACTERS = 250;
export const REFRESH_BEFORE_EXP_IN_MINS = 0;
export const EXPIRY_TIME_OPTIONS = ['days', 'date'];
export const BIN_TABLE_DEFAULT_HEIGHT = 340;
export const BIN_SIDEBAR_DEFAULT_WIDTH = 180;
export const EMPTY_DATA_STRING = 'NULL';
export const ETL_EXPIRED_STATUS = 'Expired By Debit Network Update';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const INVALID_DATE = 'Invalid Date';
export const REQUEST_DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'MM/dd/yyyy hh:mm a';
export const DATE_TIME_FORMAT_FOR_DATE_PICKER = 'MM/DD/YYYY hh:mm a';
export const DATE_FORMAT_FOR_DATE_PICKER = 'MM/DD/YYYY';
export const DATE_ISO_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const DATE_FORMAT_DATAVIEW = 'YYYY-MM-DD[T]HH:mm:ss.SSS';
export const DATE_ISO = 'YYYY-MM-DD';
export const DATABASE_UTC_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const ROLE_PERMISSIONS = [
    'dashboard',
    'dashboard.detailedView',
    'binManagement',
    'bin',
    'bin/viewer/editbin',
    'bin/viewer',
    'bin/overrides',
    'bin/mapping',
    'bin/mapping/details',
    'binviewer.override',
    'binviewer.export',
    'override',
    'fees',
    'rtr',
    'dataviews',
    'fee',
    'fee/bridge',
    '/routing/profiles',
    '/reports/costsavingsbymccinternalmerchant',
    '/reports/RoutingSummaryInternal',
    '/reports/DecisionDiscrepancyInternal',
];

export const LEGEND_DRAWER_WIDTH = 390;
export const APP_DEFAULT_TIME_ZONE = 'US/Eastern';
export const DATA_TABLE_DATE_FORMAT = 'MM/DD/YYYY, hh:mm:ss A';
export const DATA_FILE_DATE_FORMAT = 'MM/DD/YYYY hh:mm:ss A';
export const DATE_FORMAT_FOR_EXPORT = 'YYYY-MM-DD hh:mm:ss.SSS';
export const COLUMN_AND_FIELD_NAME_PRODUCT_TYPES = 'product_types';